import {
  GET_BANK_TRANSACTIONS_REQUEST,
  GET_BANK_TRANSACTIONS_SUCCESS,
  GET_BANK_TRANSACTIONS_FAILURE,
  CANCEL_BANK_TRANSACTION_SUCCESS,
  CANCEL_BANK_TRANSACTION_FAILURE
} from 'Store/constants';
import axios from 'axios';
import queryString from 'query-string';
import { openModal, closeModal } from './modalActions';
import { updateUserBalance } from './authActions';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getBankTransactions = ({
  startDate,
  endDate
}) => async dispatch => {
  try {
    dispatch({
      type: GET_BANK_TRANSACTIONS_REQUEST
    });

    const urlWithQueryParams = queryString.stringifyUrl({
      url: `${API_GATEWAY}/account/payment-transfers`,
      query: { startDate, endDate }
    });

    const res = await axios.get(urlWithQueryParams);

    dispatch({
      type: GET_BANK_TRANSACTIONS_SUCCESS,
      payload: res.data
    });
  } catch (e) {
    dispatch({
      type: GET_BANK_TRANSACTIONS_FAILURE,
      payload: 'Not Fetched'
    });
  }
};

export const cancelBankTransaction = (transactionId, activeDateRange) => async dispatch => {
  try {

    const res = await axios.put(API_GATEWAY + '/withdraw', { id: transactionId });

    dispatch(closeModal('cancelTransactionModal'));
    dispatch(openModal('cancelTransactionSuccess'));

    dispatch({
      type: CANCEL_BANK_TRANSACTION_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch(closeModal('cancelTransactionModal'));
    dispatch(openModal('cancelTransactionFailure'));

    dispatch({
      type: CANCEL_BANK_TRANSACTION_FAILURE,
      payload: 'Not Cancelled'
    });
  }
  dispatch(getBankTransactions(activeDateRange));
  dispatch(updateUserBalance());
};

